import {Component, ComponentFactoryResolver, OnDestroy, OnInit} from '@angular/core';
import {DialogService} from '@shared/services/dialog-service';
import {FieldDefinition} from '@shared/models/field-definition';
import {DialogModel} from '@shared/models/dialog.model';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';

@Component({
    standalone: false,
    selector: 'particle-treaty-rate-cell',
  templateUrl: './treaty-rate-cell.component.html',
  styleUrls: ['./treaty-rate-cell.component.scss']
})
export class TreatyRateCellComponent implements OnInit, OnDestroy {

  item: any;
  fieldDefinition: FieldDefinition;
  unSubscribe$ = new Subject<void>();
  constructor(private dialogService: DialogService,
              private componentFactoryResolver: ComponentFactoryResolver) {
    console.log(this.fieldDefinition);
    console.log(this.item);
  }

  ngOnInit() {
    console.log(this.fieldDefinition);
    console.log(this.item);
  }

  openProgressiveBlock() {
    const dialogModel = DialogModel.create('Progressive Block', 'ProgressiveBlockDialogComponent', {data: this.item.cells[this.fieldDefinition.key].value.blocks});
    dialogModel.cancelCaption = null;
    dialogModel.okCaption = 'Close';
    // dialogModel.componentFactoryResolver = this.componentFactoryResolver;
    this.dialogService.showOkCancelDialog(dialogModel).subscribe(state => {});
  }

  openFootnoteDialog() {
    const dialogModel = DialogModel.create('Footnote', 'FootnoteDialogComponent', {data: this.item.cells[this.fieldDefinition.key].value.footnote});
    dialogModel.cancelCaption = null;
    dialogModel.okCaption = 'Close';
    // dialogModel.componentFactoryResolver = this.componentFactoryResolver;
    this.dialogService.showOkCancelDialog(dialogModel).pipe(takeUntil(this.unSubscribe$)).subscribe(state => {});
  }
ngOnDestroy() {
  this.unSubscribe$.next();
  this.unSubscribe$.complete();
}
}
